import React from 'react';
import { RotateCcw } from 'lucide-react';
import LegalPageLayout, { LegalSection } from './LegalPageLayout';

const ReturnPolicyPage = ({ totalItems, totalFavorites, setCurrentPage }) => {
  return (
    <LegalPageLayout
      title="سياسة الإرجاع"
      icon={<RotateCcw className="h-8 w-8" />}
      lastUpdated="17 يوليو 2026"
      totalItems={totalItems}
      totalFavorites={totalFavorites}
      setCurrentPage={setCurrentPage}
    >
      <LegalSection title="مقدمة">
        <p>
          نسعى في صيدلية الريان لضمان رضاك التام عن كل طلب. في حال وجود أي مشكلة في المنتج
          المستلم، يمكنك مراجعة سياسة الإرجاع والاستبدال الموضحة أدناه.
        </p>
      </LegalSection>

      <LegalSection title="شروط قبول الإرجاع">
        <ul className="list-inside list-disc space-y-2">
          <li>يجب تقديم طلب الإرجاع خلال 48 ساعة من استلام الطلب.</li>
          <li>يجب أن يكون المنتج بحالته الأصلية، مغلقًا وغير مستخدم، وبعبوته الأصلية.</li>
          <li>الاحتفاظ بفاتورة الشراء ضروري لإتمام عملية الإرجاع.</li>
        </ul>
      </LegalSection>

      <LegalSection title="المنتجات غير القابلة للإرجاع">
        <p>
          نظرًا لطبيعتها الحساسة، لا يمكن إرجاع أو استبدال المنتجات التالية إلا في حالة وجود
          عيب مصنعي أو خطأ في الشحن:
        </p>
        <ul className="list-inside list-disc space-y-2">
          <li>الأدوية التي تتطلب وصفة طبية بعد فتح العبوة.</li>
          <li>مستحضرات العناية الشخصية ومستحضرات التجميل المفتوحة.</li>
          <li>المنتجات التي تتطلب تبريدًا خاصًا بعد استلامها.</li>
        </ul>
      </LegalSection>

      <LegalSection title="خطوات الإرجاع">
        <p>
          للبدء في عملية الإرجاع، تواصل مع فريق خدمة العملاء عبر صفحة "اتصل بنا" مع ذكر رقم
          الطلب وسبب الإرجاع، وسيقوم فريقنا بمراجعة الطلب والتواصل معك لترتيب الاستلام.
        </p>
      </LegalSection>

      <LegalSection title="استرداد المبالغ">
        <p>
          بعد استلام المنتج المرتجع والتأكد من مطابقته للشروط، يتم استرداد المبلغ خلال 5 إلى 7
          أيام عمل بنفس وسيلة الدفع الأصلية، أو كرصيد يمكن استخدامه في طلبات لاحقة حسب رغبتك.
        </p>
      </LegalSection>
    </LegalPageLayout>
  );
};

export default ReturnPolicyPage;
